// Simple, reusable ripple utility for click interactions.
// Usage: addRipple(event, { target, color, opacity, duration })

export default function addRipple(event, options = {}) {
  try {
    const prefersReduced =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReduced) return

    const target = options.target || event.currentTarget
    if (!target) return

    const color = options.color || 'rgba(0,0,0,0.12)'
    const duration = options.duration || 450

    // Ensure target can contain the ripple
    const computed = window.getComputedStyle(target)
    if (computed.position === 'static') {
      target.style.position = 'relative'
    }
    target.style.overflow = target.style.overflow || 'hidden'

    const rect = target.getBoundingClientRect()
    const size = Math.max(rect.width, rect.height)
    const radius = size / 2

    const circle = document.createElement('span')
    circle.style.position = 'absolute'
    circle.style.borderRadius = '50%'
    circle.style.pointerEvents = 'none'
    circle.style.width = `${size}px`
    circle.style.height = `${size}px`
    circle.style.left = `${event.clientX - rect.left - radius}px`
    circle.style.top = `${event.clientY - rect.top - radius}px`
    circle.style.background = color
    circle.style.opacity = '0.35'
    circle.style.transform = 'scale(0)'
    circle.style.transition = `transform ${duration}ms ease-out, opacity ${duration}ms ease-out`
    circle.style.zIndex = '1'

    // Remove any existing ripple quickly to avoid stacking
    const existing = target.querySelector('span[data-ripple]')
    if (existing) existing.remove()
    circle.setAttribute('data-ripple', 'true')

    target.appendChild(circle)

    // Kick off animation
    requestAnimationFrame(() => {
      circle.style.transform = 'scale(3)'
      circle.style.opacity = '0'
    })

    const cleanup = () => circle.remove()
    circle.addEventListener('transitionend', cleanup, { once: true })
  } catch {
    // no-op on environments without DOM
  }
}
